import r from "../../../tracking/tracking-mixin.vue.js";
import { resolveComponent as t, createBlock as l, openBlock as i, withCtx as m, createVNode as c } from "vue";
import s from "../../../_virtual/_plugin-vue_export-helper.js";
import u from "../../../utils/mixins/theme/theme.vue.js";
import d from "../../../atoms/logo/logo.vue.js";
import f from "../../../atoms/anchor-element/anchor-element.vue.js";
const _ = {
  name: "DsHeaderLogoLink",
  components: { DsAnchorElement: f, DsLogo: d },
  mixins: [u, r],
  props: {
    /**
         * url, href attribute content
         */
    url: { type: String, required: !0 },
    /**
         * nuxt, when is set to true it will render a nuxt link (vue router link)
         */
    nuxt: { type: Boolean, default: !1 },
    /**
         * label, logo label
         */
    label: { type: String, default: "" },
    /**
         * ariaLabel, arial-label attribute content
         */
    ariaLabel: { type: String, required: !0 }
  }
};
function b(a, g, e, p, L, h) {
  const n = t("DsLogo"), o = t("DsAnchorElement");
  return i(), l(o, {
    "tracking-data": { "component-name": a.$options.name, text: e.label || e.ariaLabel, level: 1, ...a.trackingDataProvided },
    url: e.url,
    "aria-label": e.ariaLabel,
    nuxt: e.nuxt,
    class: "header-nav__logo ds-button-link ds-button-link--primary"
  }, {
    default: m(() => [
      c(n, {
        "aria-label": e.ariaLabel,
        label: e.label,
        theme: a.theme
      }, null, 8, ["aria-label", "label", "theme"])
    ]),
    _: 1
  }, 8, ["tracking-data", "url", "aria-label", "nuxt"]);
}
const B = /* @__PURE__ */ s(_, [["render", b]]);
export {
  B as default
};
